import { render, staticRenderFns } from "./FinalResults.vue?vue&type=template&id=b86fcec6&"
import script from "./FinalResults.vue?vue&type=script&lang=js&"
export * from "./FinalResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports